export default {
  id: 'ScheduleDisplayer',
  code: 'CN',
  text: {

    "Weekly Schedule": "周课表",
    "Daily Schedule": "日课表",
    'Next Week': '下一周',
    'This Week': '这周',
    'Previous Week': '上一周',
    'Tomorrow': '明天',
    'Today': '今天',
    'Yesterday': '昨天',
    'Morning': '上午',
    'Afternoon': '下午',
    'Teacher': '老师',
    'Classroom': '教室'
  }
}



// WEBPACK FOOTER //
// ./src/shared/ScheduleDisplayer/locale.js